import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import Stack from '@mui/material/Stack';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useIsMobile } from '@repo/mui-config/hooks';
import { Button } from '@repo/ui';

import { useLoanProcessSetCurrentModalState } from '@/components/loan-process/hooks/use-loan-process-set-current-modal-state';
import { LoanProcessModalHeader } from '@/components/loan-process/loan-process-modal/loan-process-modal-header';
import { LoanProcessStatusIconWrapper } from '@/components/loan-process/loan-process-status-icon-wrapper';
import { useLoanProcessStore } from '@/components/loan-process/store/loan-process.store';

export function BlockNewApplicationSubmit() {
  const isMobile = useIsMobile();
  useLoanProcessSetCurrentModalState('ApplicationProcessing');
  const { t } = useTranslation();

  const {
    actions: { clearLoanProcessStore },
  } = useLoanProcessStore();

  const closeModal = () => {
    clearLoanProcessStore();
  };

  return (
    <Box data-testid="block-new-application-submit" sx={{ px: isMobile ? 2 : 4, py: 4 }}>
      <LoanProcessModalHeader containerSx={{ mb: isMobile ? 4 : 8 }} />
      <Stack
        alignContent="center"
        alignItems="center"
        gap={7}
        sx={{ marginBottom: '64px', paddingX: '20px' }}
      >
        <Typography component="p" textAlign="center" variant="h5">
          {t('loanProcess.loanSteps.application.blockNewApplicationSubmit.title.apologise')}
          <br />
          {t('loanProcess.loanSteps.application.blockNewApplicationSubmit.title.reason')}
        </Typography>
        <LoanProcessStatusIconWrapper iconType="info">
          <InfoOutlinedIcon />
        </LoanProcessStatusIconWrapper>
        <Typography sx={{ marginY: 2 }} textAlign="center">
          {t('loanProcess.loanSteps.application.blockNewApplicationSubmit.description')}
        </Typography>
      </Stack>
      <Button
        color="secondary"
        data-testid="application-negative-button"
        fullWidth
        onClick={closeModal}
        sx={{ paddingY: { md: '14px', xs: '8px' } }}
        variant="contained"
      >
        {t('loanProcess.loanSteps.application.negative.button')}
      </Button>
    </Box>
  );
}
